/**
 * 録音した Blob から PCM サンプルを取り出して品質チェックに使うためのヘルパ。
 *
 * AudioContext.decodeAudioData は環境差が大きいので薄くラップして
 * テストでモックしやすくする。
 *
 * @graph-stack voice-enrollment
 * @graph-domain Engineering
 * @graph-business 録音 Blob を AudioContext で PCM 化するブリッジ層
 * @graph-connects none
 */

interface DecodedAudio {
  samples: Float32Array;
  sampleRate: number;
}

/**
 * @graph-stack voice-enrollment
 * @graph-domain Engineering
 * @graph-business Blob を AudioContext.decodeAudioData で PCM サンプル列に変換する。テストで AudioContext を差し替え可能
 * @graph-connects none
 */
export async function decodeAudioBlob(
  blob: Blob,
  audioContextFactory: () => AudioContext = () =>
    new (
      window.AudioContext ||
      (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext
    )(),
): Promise<DecodedAudio> {
  const arrayBuffer = await blob.arrayBuffer();
  const ctx = audioContextFactory();
  const audioBuffer = await ctx.decodeAudioData(arrayBuffer);
  const samples = audioBuffer.getChannelData(0);
  const sampleRate = audioBuffer.sampleRate;
  await ctx.close();
  return { samples, sampleRate };
}
